const STORAGE_KEY = 'customFieldStore'

/**
 * Load custom fields from localStorage
 */
function loadFromStorage(): any {
  if (typeof window === 'undefined') return undefined

  try {
    const stored = localStorage.getItem(STORAGE_KEY)
    return stored ? JSON.parse(stored) : undefined
  } catch {
    return undefined
  }
}

/**
 * Save custom fields to localStorage
 */
function saveToStorage(data: any): void {
  if (typeof window === 'undefined') return

  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(data))
  } catch (e) {
    console.warn('[customFieldStore] Failed to persist to localStorage:', e)
  }
}

export const useCustomFieldStore = defineStore('customField', () => {
  // Initialize from localStorage if available
  const customFields = ref<any>(loadFromStorage())

  function setData(data: any) {
    customFields.value = {
      ...(customFields.value ?? {}),
      ...data
    }
    // Persist to localStorage
    saveToStorage(customFields.value)
  }

  function getData(property?: string) {
    // If customFields is empty but localStorage has data, reload it
    if (!customFields.value && typeof window !== 'undefined') {
      const stored = loadFromStorage()
      if (stored) {
        customFields.value = stored
      }
    }

    return property ? customFields?.value?.[property] : customFields?.value
  }

  return {
    setData,
    getData
  }
})
